
/**
 * @param {Array}
 * @return: Object
 */
export function getDict(dict = []) {
  if (!Array.isArray(dict) || !dict.length) {
    Promise.reject('參數為數組')
    return
  }
  // eslint-disable-next-line no-new-object
  const newDict = new Object()
  const dictStorage = JSON.parse(sessionStorage.dict)
  for (const v of dict) {
    // newDict[v] = this.$store.state.dictTypes[v]
    newDict[v] = dictStorage[v]
  }
  return newDict
}

/**
 * @param {func,wait}
 * @return: function
 */
export function throttle(func, wait) {
  let previous = 0
  return function() {
    const now = Date.now()
    const context = this
    const args = arguments
    if (now - previous > wait) {
      func.apply(context, args)
      previous = now
    }
  }
}
